<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('accountMunicipality.details.municipality_id') }}</label></td>
      <td>
        <router-link :to="municipalityLink(details)">
          {{ details.municipality_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('accountMunicipality.details.initiator') }}</label></td>
      <td>{{ details.initiator }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.description') }}</label></td>
      <td>{{ details.description }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata" /></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.createdBy') }}</label></td>
      <td>{{ details.created_by }}</td>
    </tr>
  </table>
</template>
<script>

import MetaDataDetails from "src/components/MetaData/MetaDataDetails";
import linkUtils from "@/util/link_utils";

export default {
  name: 'AccountMunicipalityDetails',
  components: {
    MetaDataDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    municipalityLink(details) {
      return linkUtils.municipalityPath(this.$router, {id: details.municipality_id});
    },
  },
};
</script>
<style></style>
